<div class="auth-callback">
  <div class="auth-callback-card">
    <img src="assets/SCRAII_LoginLogo.svg" alt="SCRAII" class="auth-callback-logo" />
    <p class="auth-callback-status" *ngIf="statusMessage">{{ statusMessage }}</p>
    <p class="auth-callback-error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>
</div>
